export const storageKeys = {
	accessToken: 'handler:accessToken',
	name: 'handler:name',
	email: 'handler:email',
	admin: 'handler:admin',
	theme: 'handler:theme'
};

export const AUTH_STORAGE_KEYS = [
	storageKeys.accessToken,
	storageKeys.admin,
	storageKeys.email,
	storageKeys.name
] as const;

export function clearAuthStorage() {
	for (const key of AUTH_STORAGE_KEYS) {
		localStorage.removeItem(key);
	}
}
